import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import concatClassNames from 'utils/classNames';
import useToggle from 'hooks/useToggle';
import { isUserLoggedIn } from 'utils/auth';
import CookiePolicy from 'components/cookie-policy/CookiePolicy';
import './PageLayout.scss';

interface PageLayoutProps {
  children: ReactNode
}

const PageLayout = ({ children }: PageLayoutProps) => {
  const { t } = useTranslation();
  const isLoggedIn = isUserLoggedIn();
  const [isNavigationMenuOpen, toggleNavigationMenu] = useToggle(false);
  const [isProfileMenuOpen, toggleProfileMenu] = useToggle(false);

  const isMenuOpen = isNavigationMenuOpen || (isProfileMenuOpen && isLoggedIn);
  return (
    <div className={concatClassNames('flex flex-column page-layout', isMenuOpen ? 'menu-opened' : '')}>
      <a className="skip-link" href="#main-content">{t('common.skipToContent')}</a>
      <Header
        isNavigationMenuOpen={isNavigationMenuOpen}
        toggleNavigationMenu={toggleNavigationMenu}
        isProfileMenuOpen={isProfileMenuOpen}
        toggleProfileMenu={toggleProfileMenu}
      />
      <main id="main-content" tabIndex={-1} className="flex flex-column page-layout-main">
        {children}
      </main>
      <CookiePolicy/>
      <Footer/>
    </div>
  );
};

export default PageLayout;
